import React from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import Loader from "../../Loader/Loader";
import { icons } from "../../../constants";

// Shared shell for the add/edit modals (user, group, vehicle, osoba, ...):
// a sticky action header (registered-by or title on the left, Save/Close on
// the right) above a body that's one column (just the form) or two (form +
// a side panel — History, Comments, whatever's relevant for that entity).
const EditModalShell = ({
  headerInfo,
  onSave,
  onClose,
  onDelete,
  saveLabel,
  closeLabel,
  deleteLabel,
  isLoading,
  sidePanel,
  actionsBar,
  children,
  className,
  t,
}) => {
  return (
    <div className={`edit-modal-shell ${className || ""}`}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex-direction-row items-center justify-between edit-modal-shell-header">
            <div className="edit-modal-shell-header-info">{headerInfo}</div>
            <div className="flex-direction-row gap-12 edit-modal-shell-header-actions">
              {onSave && (
                <AccreditationButton
                  type="save"
                  title={saveLabel || t?.("BTN_SAVE") || "Sačuvaj"}
                  onClick={onSave}
                  className="modal-shell-action"
                  icon={icons.save_blue}
                />
              )}
              {onDelete && (
                <AccreditationButton
                  type="delete"
                  title={deleteLabel || t?.("BTN_DELETE") || "Obriši"}
                  onClick={onDelete}
                  className="modal-shell-action"
                  icon={icons.trash_red}
                />
              )}
              <AccreditationButton
                type="close"
                title={closeLabel || t?.("BTN_CLOSE") || "Zatvori"}
                onClick={onClose}
                className="modal-shell-action"
                icon={icons.close_neutral}
              />
            </div>
          </div>
          {actionsBar && (
            <div className="edit-modal-shell-actions-bar">{actionsBar}</div>
          )}
          <div className="flex-direction-row edit-modal-shell-body">
            <div className="flex-direction-column gap-24 edit-modal-shell-main">
              {children}
            </div>
            {sidePanel && (
              <div className="flex-direction-column gap-12 edit-modal-shell-side">
                {sidePanel}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default EditModalShell;
